/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OverallCpvStats } from './OverallCpvStats';
import {
    OverallCpvStatsFromJSON,
    OverallCpvStatsFromJSONTyped,
    OverallCpvStatsToJSON,
} from './OverallCpvStats';
import type { PerCpvStats } from './PerCpvStats';
import {
    PerCpvStatsFromJSON,
    PerCpvStatsFromJSONTyped,
    PerCpvStatsToJSON,
} from './PerCpvStats';

/**
 * 
 * @export
 * @interface CpvChartSectionGenerated
 */
export interface CpvChartSectionGenerated {
    /**
     * 
     * @type {string}
     * @memberof CpvChartSectionGenerated
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CpvChartSectionGenerated
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CpvChartSectionGenerated
     */
    buyerId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CpvChartSectionGenerated
     */
    upcomingExpiries?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CpvChartSectionGenerated
     */
    lookbackPeriod?: string;
    /**
     * 
     * @type {OverallCpvStats}
     * @memberof CpvChartSectionGenerated
     */
    overallStats?: OverallCpvStats;
    /**
     * 
     * @type {Array<PerCpvStats>}
     * @memberof CpvChartSectionGenerated
     */
    perCpvStats?: Array<PerCpvStats>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CpvChartSectionGenerated
     */
    cpvCodes?: Array<string>;
}

/**
 * Check if a given object implements the CpvChartSectionGenerated interface.
 */
export function instanceOfCpvChartSectionGenerated(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CpvChartSectionGeneratedFromJSON(json: any): CpvChartSectionGenerated {
    return CpvChartSectionGeneratedFromJSONTyped(json, false);
}

export function CpvChartSectionGeneratedFromJSONTyped(json: any, ignoreDiscriminator: boolean): CpvChartSectionGenerated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'buyerId': !exists(json, 'buyer_id') ? undefined : json['buyer_id'],
        'upcomingExpiries': !exists(json, 'upcoming_expiries') ? undefined : json['upcoming_expiries'],
        'lookbackPeriod': !exists(json, 'lookback_period') ? undefined : json['lookback_period'],
        'overallStats': !exists(json, 'overall_stats') ? undefined : OverallCpvStatsFromJSON(json['overall_stats']),
        'perCpvStats': !exists(json, 'per_cpv_stats') ? undefined : ((json['per_cpv_stats'] as Array<any>).map(PerCpvStatsFromJSON)),
        'cpvCodes': !exists(json, 'cpv_codes') ? undefined : json['cpv_codes'],
    };
}

export function CpvChartSectionGeneratedToJSON(value?: CpvChartSectionGenerated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
        'buyer_id': value.buyerId,
        'upcoming_expiries': value.upcomingExpiries,
        'lookback_period': value.lookbackPeriod,
        'overall_stats': OverallCpvStatsToJSON(value.overallStats),
        'per_cpv_stats': value.perCpvStats === undefined ? undefined : ((value.perCpvStats as Array<any>).map(PerCpvStatsToJSON)),
        'cpv_codes': value.cpvCodes,
    };
}

